// src/components/Minihome/widgets/AboutCard.jsx

import { Card, CardContent, Typography, Stack, Chip } from "@mui/material";

// ✅ canModerate prop을 받도록 추가합니다.
export default function AboutCard({ home, item, canModerate }) {
    const username = home?.username || "user";
    const title = home?.title || "미니홈";
    const introText = item?.introText ?? `안녕하세요! ${username}의 공간이에요. 방문해 주셔서 고마워요 ✨`;
    const backgroundColor = item?.backgroundColor || 'rgba(255,255,255,0.8)';

    return (
        // ✅ elevation 속성을 canModerate 값에 따라 동적으로 설정합니다.
        <Card elevation={canModerate ? 2 : 0} sx={{ height: "100%", backgroundColor: backgroundColor }}>
            <CardContent>
                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                    <Typography variant="h6">{title}</Typography>
                    <Chip label={`@${username}`} size="small" />
                </Stack>
                <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
                    {introText}
                </Typography>
            </CardContent>
        </Card>
    );
}